import { message } from "antd";
import { clearAuthStorage, getTenantLoginPath } from "./companyIdentifier.js";

// Pages that are reachable without a backend user; a missing profile there is
// expected and must never bounce the visitor to login.
const publicPaths = ["/login", "/forgot-password", "/create-password", "/public/form"];

let redirecting = false;

/**
 * A session whose email has no matching backend user is unusable: warn once,
 * drop the stale credentials and send the user back to their tenant's login.
 */
export const redirectToLogin = (errorMessage = "User not found") => {
    if (redirecting) return;
    if (publicPaths.some(path => window.location.pathname.includes(path))) return;

    redirecting = true;
    message.destroy();
    message.error(errorMessage, 5);

    setTimeout(() => {
        const companyIdentifier = clearAuthStorage();
        window.location.href = getTenantLoginPath(companyIdentifier);
    }, 1500);
};

export { clearAuthStorage, getTenantLoginPath };
